import React, { useEffect} from 'react';
import { useLocation } from 'react-router-dom';

import SideBar from './sidebar.components';

const WrapperSideBar = () => {
    const location = useLocation();
    let currentPath = location.pathname;
    useEffect(() => {
        currentPath = location.pathname;
    }, [location]);

    return (
        <div>
            <SideBar currentPath={currentPath}></SideBar>
        </div>
    )
}

export default WrapperSideBar
